export default "__VITE_ASSET__Rcuq1MCh__"